import {sortBy} from 'lodash';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';


/**
 * Returns list of availability slots
 * @param {number} eventId Event ID
 * @returns array
 */
export function useEventAvailabilitySlots(eventId) {
    const slots = useSelector(state => state.events[eventId]?.availability.slots);
    return useMemo(() => sortBy(slots, 'start'), [slots]);
}
